$(function() {
  $('.jsoneditor-target').each(function() {
    var target = $(this);
    var container = $('<div class="jsoneditor-container">').insertAfter(target);

    var editor = new JSONEditor(container[0], {
      modes: ['code', 'tree'],
      onChange: function() {
        console.log("editor", JSON.stringify(editor.get()));
        target.val(JSON.stringify(editor.get()));
      }
    });

    var value;
    try {
      value = JSON.parse(target.val());
    } catch (e) {
      value = undefined;
    }
    editor.set(value);
    target.hide();
  });
});
